import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/enterprise',
    component: HeaderAsideLayout,
    children: [
      { path: '/enterprise', component: () => import('@/pages/enterprise/index.vue') },
    ],
  },
]
export default list